import { IActivityDetail } from './iactivity-detail';

export interface IAspectCodeableConcept {
    coding: string;
    text: string;
    // activityDetail: IActivityDetail[];
}
